import React from 'react';
import { Card, Progress, Tag, Tooltip } from 'antd';
import { SurveyRecord, DIMENSION_COLORS, DIMENSION_NAMES } from '../types';

interface Props {
  record: SurveyRecord;
}

const ScoreBreakdown: React.FC<Props> = ({ record }) => {
  const dimCodes = ['physical', 'mental', 'relationship', 'career', 'wealth', 'meaning'];

  return (
    <div style={{ marginTop: 16 }}>
      <Card size="small" title="各维度得分" style={{ marginBottom: 16 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '8px 24px',
        }}>
          {dimCodes.map(code => {
            const score = record.dimensionScores[code] || 0;
            const color = DIMENSION_COLORS[code] || '#999';
            const pct = (score / 15) * 100;
            let label: string;
            if (score >= 12) label = '状态极佳';
            else if (score >= 9) label = '基本良好';
            else if (score >= 6) label = '需要关注';
            else label = '严重匮乏';

            return (
              <Tooltip key={code} title={`${score}/15分 — ${label}`}>
                <div>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: 13,
                    marginBottom: 4,
                  }}>
                    <span>
                      <Tag color={color} style={{ marginRight: 4 }}>{DIMENSION_NAMES[code]}</Tag>
                    </span>
                    <span style={{ fontWeight: 600, color }}>{score}/15</span>
                  </div>
                  <Progress
                    percent={pct}
                    showInfo={false}
                    strokeColor={color}
                    size="small"
                  />
                </div>
              </Tooltip>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

export default ScoreBreakdown;
